export const TABLET_BREAKPOINT = 1024
export const PHONE_BREAKPOINT = 454

export const TABLET_MEDIA_QUERY = `(max-width: ${TABLET_BREAKPOINT}px)`
export const PHONE_MEDIA_QUERY = `(max-width: ${PHONE_BREAKPOINT}px)`
